import {
  endOfMonth,
  endOfYear,
  format,
  startOfMonth,
  startOfYear,
} from 'date-fns';

export const PERIOD_PRESETS = ['day', 'month', 'year', 'custom'] as const;

export type PeriodPreset = (typeof PERIOD_PRESETS)[number];

export type SteppablePreset = Exclude<PeriodPreset, 'custom'>;

export type Period = { from: string; till: string };

const DATE_FORMAT = 'yyyy-MM-dd';

const asDateString = (date: Date) => format(date, DATE_FORMAT);

const PERIOD_BUILDERS: Record<SteppablePreset, (date: Date) => Period> = {
  day: (date) => ({ from: asDateString(date), till: asDateString(date) }),
  month: (date) => ({
    from: asDateString(startOfMonth(date)),
    till: asDateString(endOfMonth(date)),
  }),
  year: (date) => ({
    from: asDateString(startOfYear(date)),
    till: asDateString(endOfYear(date)),
  }),
};

export const periodForPreset = (preset: SteppablePreset, date: Date): Period =>
  PERIOD_BUILDERS[preset](date);

export const presetPeriod = (preset: SteppablePreset): Period =>
  periodForPreset(preset, new Date());
